import { combineReducers } from 'redux'
import driversValidReducer from 'app/reducers/driversValidReducer'
import driversBannedReducer from 'app/reducers/driversBannedReducer'
import driversNewReducer from 'app/reducers/driversNewReducer'
import userReducer from 'app/reducers/usersReducer'
import userFAQReducer from 'app/reducers/userFAQReducer'
import bookingReducer from 'app/reducers/bookingReducer'
import driverFAQReducer from 'app/reducers/driversFAQReducer'
import bookingCancellationReducer from 'app/reducers/bookingCancellationReducer'
import tripReducer from 'app/reducers/tripReducer'
import tripCancellationReducer from 'app/reducers/tripCancellationReducer'
import dropPointReducer from 'app/reducers/dropPointReducer'
import lineReducer from 'app/reducers/lineReducer'
import payementReducer from 'app/reducers/payementReducer'
import timeslotReducer from 'app/reducers/timeSlotReducer'
import authReducer from 'app/reducers/authReducer'
import dashboardUsersReducer from 'app/reducers/dashboardUsersReducer';
import couponReducer from 'app/reducers/couponReducer'
import statsLandingReducer from 'app/reducers/statsLandingReducer'
import driverTripsReducer from "./driverTripsReducer";
import bookingsRequestsReducer from "./bookingsRequestsReducer";
import linesRequestsReducer from "./linesRequestsReducer"
import snackBarReducer from "./snackBarReducer";
import driversOperationalReducer from "./driversOperationalReducer";
import smsGatewayReducer from "./smsGatewayReducer";

export default combineReducers({
  usersList: userReducer , 
  usersFAQList : userFAQReducer , 
  driversValidList : driversValidReducer , 
  driversBannedList : driversBannedReducer , 
  driversNewList : driversNewReducer , 
  driversFAQList : driverFAQReducer , 
  bookingsList : bookingReducer , 
  bookingCancellationList : bookingCancellationReducer , 
  tripList : tripReducer , 
  tripCancellationList : tripCancellationReducer , 
  dropPointList : dropPointReducer , 
  lineList : lineReducer , 
  timeslotList : timeslotReducer , 
  payementList : payementReducer ,
  auth : authReducer,
  dashboardUsers : dashboardUsersReducer,
  codePromoList : couponReducer,
  statsLanding : statsLandingReducer,
  driverTrips : driverTripsReducer,
  bookingsRequests : bookingsRequestsReducer,
  linesRequests : linesRequestsReducer,
  snackBarInfo : snackBarReducer,
  driversOperational : driversOperationalReducer,
  smsGateway : smsGatewayReducer

})